<template>
  <div class="reader-work-selector" v-on-clickaway="away">
    <div class="browse-work-wrapper" v-if="selectedWork">
      <BrowseWork :work="selectedWork" @selected="selection => $emit('selected', selection)">
        <div class="selector-top" slot="header">
          <h4 class="selector-header">
            <BackButton @back="selectedWork = null" />
            {{ localizedWorkTitleVerbose(selectedWork) }}
          </h4>
        </div>
      </BrowseWork>
    </div>
    <div v-else class="works">
      <h4 class="selector-header">{{ $t('selectWorkTitle') }}</h4>
      <ul>
        <li v-for="work in works" :key="work.urn">
          <a href @click.prevent="selectedWork = work">{{ localizedWorkTitleVerbose(work) }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';
  import { FETCH_SUPERHEADING_SECTION_COLLATIONS } from '../constants';
  import BrowseWork from './Browse/BrowseWork.vue';
  import BackButton from './BackButton.vue';
  import mixins from '../mixins';

  export default {
    components: { BackButton, BrowseWork },
    mixins: [mixins.RouteReaderSelectionsMixin, mixins.LocalizedWorkTitleMixin, clickaway],
    props: ['initialSelectedWorkUrn', 'works'],
    data() {
      return {
        selectedWork: null,
      };
    },
    watch: {
      selectedWork: {
        immediate: true,
        handler() {
          if (this.selectedWork) {
            this.fetchContentsData();
          }
        },
      },
      works: {
        immediate: true,
        handler() {
          if (this.initialSelectedWorkUrn && !this.selectedWork) {
            const matches = this.works.filter(work => work.urn === this.initialSelectedWorkUrn);
            this.selectedWork = matches.length ? matches[0] : undefined;
          }
        },
      },
    },
    computed: {
      firstSectionIdx() {
        if (this.selectedWork) {
          const workContentData = this.$store.state.browseContentData[this.selectedWork.urn];
          return workContentData ? workContentData[0].node.sections.edges[0].node.idx : null;
        }
        return null;
      },
      hasNoPreviousSelection() {
        return !this.initialSelectedWorkUrn && this.selectedWork && this.firstSectionIdx != null;
      },
    },
    methods: {
      away() {
        if (this.hasNoPreviousSelection) {
          // Since the user has not previously made a selection,
          // but has selected a work, we should select the first section
          // for them
          this.$emit('selected', {
            work: this.selectedWork.urn,
            idx: this.firstSectionIdx,
          });
        } else {
          this.$emit('close');
        }
      },
      fetchContentsData() {
        const query = `{
          superheadings (work_Urn: "${this.selectedWork.urn}" ) {
            edges {
              node {
                id
                title
                label
                position
                sectionCollations
                sections(first: 1){
                  edges {
                    node {
                      idx
                    }
                  }
                }
              }
            }
          }
        }`;
        this.$gql(query).then((data) => {
          const payload = {
            workUrn: this.selectedWork.urn,
            data: data.superheadings.edges,
          };
          this.$store.dispatch(FETCH_SUPERHEADING_SECTION_COLLATIONS, payload);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../variables';
  #app[data-locale="ar"] {
    .selector-top, .selector-header, .works ul {
      direction: rtl;
      letter-spacing: normal;
      unicode-bidi: bidi-override;
    }
    .works li {
      direction: rtl;
      > a {
        border-right: 3px solid transparent;
        font-family: $ar-font-family;
        padding: 14px 12px;
        font-size: $ar-text-md;
        line-height: 0.667em;
        margin-bottom: 12px;
      }
      a:hover {
        border-left: unset;
        border-right: 3px solid $gray-800;
      }
    }
    .selector-header {
      font-size: 32px;
      font-family: Amiri, "Noto Serif";
      padding: 20px 10px;
    }
  }
  .reader-work-selector {
    position: absolute;
    top: 0; left: 0; right: 0;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.16);
    background: $white;
    border: 1px solid $gray-300;
    border-radius: 5px;
    padding: 10px 15px;
    overflow-y: scroll;
    max-height: calc(100vh - 25vh);
    margin: 30px 13px;
    .selector-header {
      margin: -10px -15px 10px -15px;
      padding: 5px 15px;
      font-weight: normal;
      color: $gray-300;
      background: $gray-800;
      text-transform: uppercase;
      letter-spacing: .1em;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .works ul,
  .works li {
    margin: 0;
    padding: 0;
  }
  .works li {
    a:hover {
      border-left: 3px solid $gray-800;
      background: $gray-300;
    }
    a {
      display: block;
      border-left: 3px solid transparent;
      padding: 5px 12px;
      margin-left: -15px;
      margin-right: -15px;
      text-decoration: none;
      color: $gray-700;
    }
  }
</style>
